// Copyright (c) 2023 Deere & Company

import actions from '../../actions-list';

export const updateTemporaryObjectKey = temporaryObjectKey =>

    dispatch => {

        dispatch({
            temporaryObjectKey,
            type: actions.UPDATE_DUPLICATE_PIN_PLATE_TEMPORARY_OBJECT_KEY
        });

    };



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/update-temporary-object-key.js